import { render, staticRenderFns } from "./inWardDetail.vue?vue&type=template&id=86827af6&"
import script from "./inWardDetail.vue?vue&type=script&lang=js&"
export * from "./inWardDetail.vue?vue&type=script&lang=js&"
import style0 from "./inWardDetail.vue?vue&type=style&index=0&id=86827af6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports